import React, {FC} from "react";
import {Autocomplete} from "@material-ui/lab";
import {Button, TextField, TextFieldProps} from "@material-ui/core";
import {GridFilterInputValueProps} from "@material-ui/data-grid";
import {Client, FeClient} from "../redux/types";
import {useClients} from "../redux/clients.hook";
import {getFullName} from "../../../utils";
import {useField} from "formik";
import {Add} from "@material-ui/icons";
import {CreateClientDialogForm} from "../form/CreateClientDialogForm";
import {FeOrder, OrderAddress} from "../../orders/redux/types";
import {useAppDispatch} from "../../../redux/redux.hook";
import {getOrderLastOrderOfClientThunk} from "../../orders/redux/orders.thunk";

interface ClientAutoCompleteProps {
    selectedId: string | null;
    onChange: (client: FeClient | null) => void;
    textFieldProps?: TextFieldProps;
    onNewClientCreated?: (clientId: string) => void;
}


export const ClientAutoComplete: FC<ClientAutoCompleteProps> = ({
                                                                    onChange,
                                                                    textFieldProps,
                                                                    selectedId,
                                                                    onNewClientCreated
                                                                }) => {
    const [showClientDialog, setShowClientDialog] = React.useState(false);

    const {clients} = useClients();
    const selectedClient = selectedId ? clients.find(c => c.id === selectedId) : null;
    return (
        <React.Fragment>
            <CreateClientDialogForm
                open={showClientDialog}
                onClose={() => setShowClientDialog(false)}
                withoutButton
                onCreated={onNewClientCreated}
            />
            <Autocomplete
                options={clients}
                value={selectedClient}
                getOptionLabel={(client) => getFullName(client)}
                onChange={(_event, c) =>
                    onChange(c)
                }
                noOptionsText={
                    <Button
                        fullWidth
                        startIcon={<Add/>}
                        onMouseDown={() => {
                           setShowClientDialog(true);
                        }}
                    >
                        Neu anlegen
                    </Button>
                }
                renderInput={(params) => <TextField {...textFieldProps} {...params} label="Kunde"/>}
            />
        </React.Fragment>
    )
}

type FormikClientAutoCompleteProps = Omit<TextFieldProps, 'name'> & {
    name: string;
    onNewClientCreated?: (clientId: string) => void;
};

export const FormikClientAutoComplete: FC<FormikClientAutoCompleteProps> = (props) => {
    const dispatch = useAppDispatch();
    const {name, ...restProps} = props;
    const [, meta, helpers] = useField<string | null>(name);

    const [, , serviceAddressHelpers] = useField<OrderAddress>("serviceAddress");
    const [, , invoiceAddressHelpers] = useField<OrderAddress | undefined>("invoiceAddress");

    return (
        <ClientAutoComplete
            onNewClientCreated={props.onNewClientCreated}
            selectedId={meta.value || null}
            onChange={(client) => {
                if (client) {
                    helpers.setValue(client.id);
                    dispatch(getOrderLastOrderOfClientThunk({clientId: client.id}))
                        .then((result) => {
                            const order = result.payload as FeOrder | undefined;
                            if (order) {
                                serviceAddressHelpers.setValue(order.serviceAddress);
                                invoiceAddressHelpers.setValue(order.invoiceAddress);
                            }
                        })
                        .catch(() => {
                        });
                }
            }}
            textFieldProps={{
                ...restProps,
                error: meta.touched && Boolean(meta.error),
                helperText: meta.touched && meta.error
            }}
        />
    )
}

export function ClientGridFilterInput(props: GridFilterInputValueProps) {
    const {item, applyValue} = props;

    const onChangeClient = (client: Client | null) => {
        if (client) {
            applyValue({
                ...item,
                value: client.id
            });
        }
    };

    return (<ClientAutoComplete selectedId={item.value} onChange={onChangeClient}/>);
}
